import { render, staticRenderFns } from "./storehouse.vue?vue&type=template&id=19c4862e&scoped=true"
import script from "./storehouse.vue?vue&type=script&lang=ts"
export * from "./storehouse.vue?vue&type=script&lang=ts"
import style0 from "./storehouse.vue?vue&type=style&index=0&id=19c4862e&prod&lang=scss"
import style1 from "./storehouse.vue?vue&type=style&index=1&id=19c4862e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4862e",
  null
  
)

export default component.exports